import { useEffect, useState } from "react";

import { db } from "../firebase/config";

const useLinks = () => {
  const [links, setLinks] = useState<any>({});

  useEffect(() => {
    db.collection("meta")
      .doc("links")
      .onSnapshot(async (qs) => {
        const data = qs.data();

        if (data) {
          setLinks(data);
        }
      });
  }, []);

  return links;
};

export default useLinks;
